var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "group-travel-room-data" }, [
    _c("p", [_vm._v(_vm._s(_vm.roomTypeName))]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "input-fields" },
      [
        _c("div", { staticClass: "input-fields__content" }, [
          _c("div", { staticClass: "label-input booking-field" }, [
            _c(
              "select",
              {
                domProps: { value: _vm.value.adults.length },
                on: {
                  input: function($event) {
                    return _vm.setAdultCount($event.target.value)
                  }
                }
              },
              [
                _c("option", {
                  domProps: {
                    value: 0,
                    textContent: _vm._s(_vm.translations.input.adults)
                  }
                }),
                _vm._v(" "),
                _vm._l(6, function(n) {
                  return _c(
                    "option",
                    { key: "adult_count_" + n, domProps: { value: n } },
                    [
                      _vm._v(
                        _vm._s(n) +
                          " " +
                          _vm._s(n > 1 ? "voksne" : "voksen") +
                          "\n                    "
                      )
                    ]
                  )
                })
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "svg",
              {
                staticClass: "icon-dropdown",
                attrs: {
                  xmlns: "http://www.w3.org/2000/svg",
                  viewBox: "0 0 395.65 223"
                }
              },
              [
                _c("path", {
                  staticStyle: { fill: "rgb(140, 140, 130)" },
                  attrs: {
                    d:
                      "M370.5,0a25,25,0,0,0-17.79,7.37L210.57,149.51l-12.73,12.73-12.73-12.73L43,7.37A25.16,25.16,0,1,0,7.38,43L180,215.63a25.16,25.16,0,0,0,35.58,0L388.29,43A25.17,25.17,0,0,0,370.5,0Z"
                  }
                })
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "label-input booking-field" }, [
            _c(
              "select",
              {
                domProps: { value: _vm.value.children.length },
                on: {
                  input: function($event) {
                    return _vm.setChildrenCount($event.target.value)
                  }
                }
              },
              [
                _c("option", {
                  domProps: {
                    value: 0,
                    textContent: _vm._s(_vm.translations.input.children)
                  }
                }),
                _vm._v(" "),
                _vm._l(6, function(n) {
                  return _c(
                    "option",
                    { key: "chil_count_" + n, domProps: { value: n } },
                    [
                      _vm._v(
                        _vm._s(n) +
                          " " +
                          _vm._s(n > 1 ? "børn" : "barn") +
                          "\n                    "
                      )
                    ]
                  )
                })
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "svg",
              {
                staticClass: "icon-dropdown",
                attrs: {
                  xmlns: "http://www.w3.org/2000/svg",
                  viewBox: "0 0 395.65 223"
                }
              },
              [
                _c("path", {
                  staticStyle: { fill: "rgb(140, 140, 130)" },
                  attrs: {
                    d:
                      "M370.5,0a25,25,0,0,0-17.79,7.37L210.57,149.51l-12.73,12.73-12.73-12.73L43,7.37A25.16,25.16,0,1,0,7.38,43L180,215.63a25.16,25.16,0,0,0,35.58,0L388.29,43A25.17,25.17,0,0,0,370.5,0Z"
                  }
                })
              ]
            )
          ])
        ]),
        _vm._v(" "),
        _vm._l(_vm.value.adults, function(adultData, adultDataKey) {
          return _c(
            "div",
            {
              key: "adult_data_key_" + adultDataKey,
              staticClass: "input-fields__content booking-block"
            },
            [
              _c(
                "div",
                { staticClass: "input-fields__content" },
                [
                  _c("div", { staticClass: "booking-block__header" }, [
                    _c("div", { staticClass: "booking-block__header__text" }, [
                      _c("h2", [
                        _vm._v(
                          _vm._s(_vm.translations.input.adult) +
                            " " +
                            _vm._s(adultDataKey + 1)
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "booking-block__content" },
                    [
                      _c("div", { staticClass: "label-input booking-field" }, [
                        _c(
                          "select",
                          {
                            domProps: { value: adultData.gender },
                            on: {
                              input: function($event) {
                                return _vm.setAdultData(adultDataKey, {
                                  gender: $event.target.value
                                })
                              }
                            }
                          },
                          _vm._l(_vm.translations.input.sexOptions, function(
                            txt,
                            value
                          ) {
                            return _c("option", {
                              domProps: {
                                value: value,
                                textContent: _vm._s(txt)
                              }
                            })
                          })
                        ),
                        _vm._v(" "),
                        _c(
                          "svg",
                          {
                            staticClass: "icon-dropdown",
                            attrs: {
                              xmlns: "http://www.w3.org/2000/svg",
                              viewBox: "0 0 395.65 223"
                            }
                          },
                          [
                            _c("path", {
                              staticStyle: { fill: "rgb(140, 140, 130)" },
                              attrs: {
                                d:
                                  "M370.5,0a25,25,0,0,0-17.79,7.37L210.57,149.51l-12.73,12.73-12.73-12.73L43,7.37A25.16,25.16,0,1,0,7.38,43L180,215.63a25.16,25.16,0,0,0,35.58,0L388.29,43A25.17,25.17,0,0,0,370.5,0Z"
                              }
                            })
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("input-field", {
                        staticClass: "booking-field booking-field--firstname",
                        attrs: {
                          name: _vm.translations.input.input_firstname,
                          value: adultData.firstname,
                          "icon-type": !adultData.firstname
                            ? ""
                            : _vm.checkmarkIcon
                        },
                        on: {
                          input: function(inp) {
                            return _vm.setAdultData(adultDataKey, {
                              firstname: inp
                            })
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("input-field", {
                        staticClass: "booking-field booking-field--lastname",
                        attrs: {
                          name: _vm.translations.input.input_lastname,
                          value: adultData.lastname,
                          "icon-type": !adultData.lastname
                            ? ""
                            : _vm.checkmarkIcon
                        },
                        on: {
                          input: function(inp) {
                            return _vm.setAdultData(adultDataKey, {
                              lastname: inp
                            })
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("select-date-picker", {
                        attrs: {
                          yearOffset: _vm.adultYearOffset,
                          yearsToGoBack: _vm.shownAdultYears,
                          value: adultData.birthdate
                        },
                        on: {
                          input: function(inp) {
                            return _vm.setAdultData(adultDataKey, {
                              birthdate: inp
                            })
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.errors.adults[adultDataKey], function(error) {
                    return _c("msg-block", { attrs: { type: "error" } }, [
                      _c("span", [
                        _c("strong", {
                          domProps: { textContent: _vm._s(error[0]) }
                        })
                      ])
                    ])
                  })
                ],
                2
              )
            ]
          )
        }),
        _vm._v(" "),
        _vm._l(_vm.value.children, function(childData, childDataKey) {
          return _c(
            "div",
            {
              key: "child_data_key_" + childDataKey,
              staticClass: "input-fields__content booking-block"
            },
            [
              _c(
                "div",
                { staticClass: "input-fields__content" },
                [
                  _c("div", { staticClass: "booking-block__header" }, [
                    _c("div", { staticClass: "booking-block__header__text" }, [
                      _c("h2", { staticClass: "room-data-person__heading" }, [
                        _vm._v(
                          _vm._s(_vm.translations.input.child) +
                            " " +
                            _vm._s(childDataKey + 1)
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "booking-block__content" },
                    [
                      _c("div", { staticClass: "label-input booking-field" }, [
                        _c(
                          "select",
                          {
                            domProps: { value: childData.gender },
                            on: {
                              input: function($event) {
                                return _vm.setChildrenData(childDataKey, {
                                  gender: $event.target.value
                                })
                              }
                            }
                          },
                          _vm._l(_vm.translations.input.childOptions, function(
                            txt,
                            value
                          ) {
                            return _c("option", {
                              domProps: {
                                value: value,
                                textContent: _vm._s(txt)
                              }
                            })
                          })
                        ),
                        _vm._v(" "),
                        _c(
                          "svg",
                          {
                            staticClass: "icon-dropdown",
                            attrs: {
                              xmlns: "http://www.w3.org/2000/svg",
                              viewBox: "0 0 395.65 223"
                            }
                          },
                          [
                            _c("path", {
                              staticStyle: { fill: "rgb(140, 140, 130)" },
                              attrs: {
                                d:
                                  "M370.5,0a25,25,0,0,0-17.79,7.37L210.57,149.51l-12.73,12.73-12.73-12.73L43,7.37A25.16,25.16,0,1,0,7.38,43L180,215.63a25.16,25.16,0,0,0,35.58,0L388.29,43A25.17,25.17,0,0,0,370.5,0Z"
                              }
                            })
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("input-field", {
                        staticClass: "booking-field booking-field--firstname",
                        attrs: {
                          name: _vm.translations.input.input_firstname,
                          value: childData.firstname,
                          "icon-type": !childData.firstname
                            ? ""
                            : _vm.checkmarkIcon
                        },
                        on: {
                          input: function(inp) {
                            return _vm.setChildrenData(childDataKey, {
                              firstname: inp
                            })
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("input-field", {
                        staticClass: "booking-field booking-field--lastname",
                        attrs: {
                          name: _vm.translations.input.input_lastname,
                          value: childData.lastname,
                          "icon-type": !childData.lastname
                            ? ""
                            : _vm.checkmarkIcon
                        },
                        on: {
                          input: function(inp) {
                            return _vm.setChildrenData(childDataKey, {
                              lastname: inp
                            })
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("select-date-picker", {
                        attrs: {
                          yearOffset: _vm.childYearOffset,
                          yearsToGoBack: _vm.shownChildYears,
                          value: childData.birthdate
                        },
                        on: {
                          input: function(inp) {
                            return _vm.setChildrenData(childDataKey, {
                              birthdate: inp
                            })
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.errors.children[childDataKey], function(error) {
                    return _c("msg-block", { attrs: { type: "error" } }, [
                      _c("span", [
                        _c("strong", {
                          domProps: { textContent: _vm._s(error[0]) }
                        })
                      ])
                    ])
                  })
                ],
                2
              )
            ]
          )
        })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-71ae7ae8", { render: render, staticRenderFns: staticRenderFns })
  }
}